import { call, put } from 'redux-saga/effects';
import { takeLatest } from '../../../utils/reduxSaga';

import { URLS } from '../../../consts/endpoints';
import { actions as reduxActions } from '../reducers';
import { actions as sagaActions, NEW_USER_REQUEST } from './types';
import { postData } from '../../../utils/http';
import RESPONSE_CODES from '../../../consts/responseCodes';
import Optional from '../../../utils/optional';
import mapDataForRequest from './mapDataForRequest';
import showSnackbar from '../../../utils/showSnackbar';

export function newUserSubmit(userData, client, loggedUserEmail) {
  return {
    type: sagaActions[NEW_USER_REQUEST],
    userData,
    client,
    loggedUserEmail
  };
}

export function* newUserRequest({ userData, client, loggedUserEmail }) {
  const { template, copiedUserDetails } = userData;
  const resolvedCopiedUserDetails = Optional(copiedUserDetails).or({});

  const mappedData = yield call(mapDataForRequest, {
    userData,
    client,
    template,
    loggedUserEmail,
    copiedUserDetails: resolvedCopiedUserDetails
  });

  const response = yield call(postData, {
    url: URLS.PRODUCT_ORDERS,
    passErrors: true,
    data: {
      ...mappedData
    }
  });

  if (response.status === RESPONSE_CODES.CREATED) {
    yield call(showSnackbar, {
      intlTextKey: 'MESSAGE.NEW_USER_REQUESTS_SEND',
      messageType: 'success'
    });
  }

  yield put(reduxActions.resestUserWizard());
}

function* watchNewUserRequest() {
  yield takeLatest(sagaActions[NEW_USER_REQUEST], newUserRequest);
}

export default watchNewUserRequest();
